import { Group, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import classes from '../CustomPage.module.css';

function ActionCell({ row }) {



    return (
        <>
            <Group justify="center" p="md" >

                <Link to={`/customPages/${row.id}/edit`}><div
                    className={classes.icon_button}
                ><Tooltip label="Edit">
                        <IconEdit style={{ color: 'white', fontSize: '20px', alignItems: 'center' }} />
                    </Tooltip></div></Link></Group>

        </>
    )
}

export default ActionCell
